/** @jsxImportSource @emotion/react */
import { Autocomplete, OutlinedInput, Button, Checkbox, Divider, FormControl, FormControlLabel, FormHelperText, Grid, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import { StyledTextField } from '../../Components/CustomTextfield';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useEffect, useState } from 'react';
import Upload from '../../Components/Upload';
import { add } from 'lodash';

function NomineeFields(props) {
    const { store, nomineeCount, formik, localeText, pincodeOptions, getOptionComponent, handlePincodeSearch, relationOptions, prefixOptions, deleteNominee, isMinorNominee, open, setOpen, identityDetails } = props
    let nomineeField = []

    const handleAddressSame = (e, index, isGuardian) => {
        let value = e.currentTarget.checked
        if (value) {
            formik.setFieldValue(isGuardian ? "guardAddress" + index : "address" + index, formik?.values?.address1)
            formik.setFieldValue(isGuardian ? "guardPincode" + index : "pincode" + index, formik?.values?.pincode1)
            formik.setFieldValue(isGuardian ? "guardCity" + index : "city" + index, formik?.values?.city1)
            formik.setFieldValue(isGuardian ? "guardState" + index : "state" + index, formik?.values?.state1)
            formik.setFieldValue(isGuardian ? "guardCountry" + index : "country" + index, formik?.values?.country1)
        }
    }

    const handlePrimaryAddressSame = (e, index, isPrimary) => {
        let value = e.currentTarget.checked

        let addr = [store?.addressFatcaDetails?.corrAddress1, store?.addressFatcaDetails?.corrAddress2, store?.addressFatcaDetails?.corrAddress3, store?.addressFatcaDetails?.corrAddress4]

        if (value) {
            formik.setFieldValue(isPrimary ? "address" + index : "address" + index,
                `${addr[0] ? addr[0] : ""}${addr[1] ? ", " + addr[1] : ""}${addr[2] ? ", " + addr[2] : ""}${addr[3] ? ", " + addr[3] : ""}`
            )

            formik.setFieldValue(isPrimary ? "pincode" + index : "pincode" + index, store?.addressFatcaDetails?.corrAddressPincode)
            formik.setFieldValue(isPrimary ? "city" + index : "city" + index, store?.addressFatcaDetails?.corrAddressCity)
            formik.setFieldValue(isPrimary ? "state" + index : "state" + index, store?.addressFatcaDetails?.corrAddressState)
            formik.setFieldValue(isPrimary ? "country" + index : "country" + index, store?.addressFatcaDetails?.corrAddressCountry)
        }
    }


    for (let i = 1; i <= nomineeCount; i++) {
        nomineeField.push(
            <>
                {i > 1 && <Grid item xs={12}>
                    <Divider />
                </Grid>}
                <Grid container item xs={12} spacing={3} alignItems="center">
                    <Grid item>
                        <Typography variant="body1" css={{ fontWeight: "bold" }}>
                            {localeText?.nomineeDetailsNominee + i}
                        </Typography>
                    </Grid>



                    {i > 1 && <Grid item>
                        <Button size="small" variant="outlined" color="primary" onClick={() => deleteNominee(i)}>
                            {localeText?.nomineeDetailsDeleteNominee}
                        </Button>
                    </Grid>}
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                    <FormControl required fullWidth error={formik.touched["prefix" + i] && Boolean(formik.errors["prefix" + i])} css={{ marginTop: "10px" }}>
                        <InputLabel
                            shrink
                        >
                            {localeText?.nomineeDetailsPrefix}
                        </InputLabel>
                        <Select
                            id={"prefix" + i}
                            name={"prefix" + i}
                            value={formik.values["prefix" + i]}
                            onChange={formik.handleChange}
                            size="small"
                            input={
                                <OutlinedInput
                                    notched
                                    label="Prefix"
                                />
                            }
                        >
                            <MenuItem value="">{localeText?.nomineeDetailsSelectValue}</MenuItem>
                            {prefixOptions.map(opt => <MenuItem value={opt.value}>{opt.label}</MenuItem>)}
                        </Select>
                        <FormHelperText>{formik.touched["prefix" + i] && formik.errors["prefix" + i]}</FormHelperText>
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                    <StyledTextField id={"nameOfNominee" + i} name={"nameOfNominee" + i} css={{ marginTop: "10px" }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        required
                        inputProps={{ maxLength: 50 }}
                        value={formik.values["nameOfNominee" + i]}
                        error={formik.touched["nameOfNominee" + i] && Boolean(formik.errors["nameOfNominee" + i])}
                        helperText={formik.touched["nameOfNominee" + i] && formik.errors["nameOfNominee" + i]} fullWidth
                        label={localeText?.nomineeDetailsNameofNominee} variant="outlined"
                        onChange={(e) => {
                            formik.setFieldValue("nameOfNominee" + i,(e.target.value).toUpperCase() )
                        }}
                    />
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker css={{ width: "100%", marginTop: "10px" }}
                            inputFormat="DD/MM/YYYY"
                            id={"dateOfBirth" + i}
                            name={"dateOfBirth" + i}
                            value={formik.values["dateOfBirth" + i] || null}
                            maxDate={new Date()}
                            label={localeText?.nomineeDetailsDateofBirth}
                            onChange={e => {
                                formik.setFieldValue(["dateOfBirth" + i], e?.$d)
                                formik.setFieldValue("isGuardian" + i, isMinorNominee(e?.$d))
                            }}
                            renderInput={(params) => 
                            <StyledTextField
                                size="small"
                                fullWidth
                                required
                                error={formik.touched["dateOfBirth" + i] && Boolean(formik.errors["dateOfBirth" + i])}
                                helperText={formik.touched["dateOfBirth" + i] && formik.errors["dateOfBirth" + i]}
                                {...params}
                            />}
                        />
                    </LocalizationProvider>
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                    <FormControl required fullWidth error={formik.touched["relationship" + i] && Boolean(formik.errors["relationship" + i])} css={{ marginTop: "10px" }}>
                        <InputLabel
                            shrink
                        >
                            {localeText?.nomineeDetailsRelationshipwithNominee}
                        </InputLabel>
                        <Select
                            id={"relationship" + i}
                            name={"relationship" + i}
                            value={formik.values["relationship" + i]}
                            onChange={formik.handleChange}
                            size="small"
                            input={
                                <OutlinedInput
                                    notched
                                    label={localeText?.nomineeDetailsRelationshipwithNominee}
                                />
                            }

                        >
                            <MenuItem value="">{localeText?.nomineeDetailsSelectValue}</MenuItem>
                            {relationOptions.filter(opt => opt.relationType == "Nominee").map(opt => <MenuItem value={opt.relationship}>{opt.relationship}</MenuItem>)}
                        </Select>
                        <FormHelperText>{formik.touched["relationship" + i] && formik.errors["relationship" + i]}</FormHelperText>
                    </FormControl>
                </Grid>

                {i == 1 && <Grid item xs={12}>
                    <FormControl>
                        <FormControlLabel control={<Checkbox name={"primaryNomAddressSameAs" + i} id={"primaryNomAddressSameAs" + i} checked={formik.values["primaryNomAddressSameAs" + i]} onChange={e => { handlePrimaryAddressSame(e, i) }} />}
                            label={<Typography variant='body2'>
                                {localeText?.nomineeDetailsAddressPrimaryApplicant}
                            </Typography>}
                        />
                    </FormControl>
                </Grid>}

                {i > 1 && <Grid item xs={12}>
                    <FormControl>
                        <FormControlLabel control={<Checkbox name={"nomAddressSameAs" + i} id={"nomAddressSameAs" + i} checked={formik.values["nomAddressSameAs" + i]} onChange={e => { handleAddressSame(e, i) }} />}
                            label={<Typography variant='body2'>
                                {localeText?.nomineeDetailsAddressNominee1}
                            </Typography>}
                        />
                    </FormControl>
                </Grid>}
                <Grid item xs={12} md={6} lg={3}>
                    <StyledTextField id={"address" + i} name={"address" + i} css={{ marginTop: "10px" }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        required
                        inputProps={{ maxLength: 200 }}
                        value={formik.values["address" + i]}
                        error={formik.touched["address" + i] && Boolean(formik.errors["address" + i])}
                        helperText={formik.touched["address" + i] && formik.errors["address" + i]} fullWidth
                        label={localeText?.nomineeDetailsAddress} variant="outlined"
                        onChange={formik.handleChange}
                    />
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                    <Autocomplete
                        css={{ marginTop: "10px" }}
                        key={formik.values["pincode" + i]}
                        id={"pincode" + i} name={"pincode" + i}
                        value={formik.values["pincode" + i] || ""}
                        open={open?.["nom" + i]}
                        onOpen={() => {
                            setOpen({ ...open, ["nom" + i]: true });
                        }}
                        onClose={() => {
                            setOpen({ ...open, ["nom" + i]: false });
                        }}
                        options={pincodeOptions}
                        disablePortal
                        filterOptions={(x) => x}
                        loading={open?.["nom" + i] && pincodeOptions.length == 0}
                        renderOption={(props, searchedItem, state) => {
                            return getOptionComponent(searchedItem, i, false)
                        }}
                        isOptionEqualToValue={(option, value) => { return option.pinCode === value }}
                        getOptionLabel={(option) => { return option }}
                        renderInput={(params) => <StyledTextField {...params} fullWidth variant="outlined" label={localeText?.nomineeDetailsPINcode}
                            onChange={e => handlePincodeSearch(e)}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            size="small"
                            required
                            id={"pincode" + i} name={"pincode" + i}
                            error={formik.touched["pincode" + i] && Boolean(formik.errors["pincode" + i])}
                            helperText={formik.touched["pincode" + i] && formik.errors["pincode" + i]}
                        />}
                    />
                </Grid>
                <Grid item xs={12} md={3} lg={3}>
                    <StyledTextField id={"city" + i} name={"city" + i} css={{ marginTop: "10px" }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        required
                        value={formik.values["city" + i]}
                        error={formik.touched["city" + i] && Boolean(formik.errors["city" + i])}
                        helperText={formik.touched["city" + i] && formik.errors["city" + i]} fullWidth
                        label={localeText?.nomineeDetailsCity} variant="outlined" disabled
                        onChange={formik.handleChange}
                    />
                </Grid>
                <Grid item xs={12} md={3} lg={3}>
                    <StyledTextField id={"state" + i} name={"state" + i} css={{ marginTop: "10px" }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        required
                        value={formik.values["state" + i]}
                        error={formik.touched["state" + i] && Boolean(formik.errors["state" + i])}
                        helperText={formik.touched["state" + i] && formik.errors["state" + i]} fullWidth
                        label={localeText?.nomineeDetailsState} variant="outlined" disabled
                        onChange={formik.handleChange}
                    />
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                    <StyledTextField id={"country" + i} name={"country" + i} css={{ marginTop: "10px" }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        required
                        value={formik.values["country" + i]}
                        error={formik.touched["country" + i] && Boolean(formik.errors["country" + i])}
                        helperText={formik.touched["country" + i] && formik.errors["country" + i]} fullWidth
                        label={localeText?.nomineeDetailsCountry} variant="outlined" disabled
                        onChange={formik.handleChange}
                    />
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                    <StyledTextField id={"mobile" + i} name={"mobile" + i} css={{ marginTop: "10px" }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        required
                        inputProps={{ maxLength: 10 }}
                        value={formik.values["mobile" + i]}
                        error={formik.touched["mobile" + i] && Boolean(formik.errors["mobile" + i])}
                        helperText={formik.touched["mobile" + i] && formik.errors["mobile" + i]} fullWidth
                        label={localeText?.nomineeDetailsMob} variant="outlined"
                        onChange={formik.handleChange}
                    />
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                    <StyledTextField id={"emailID" + i} name={"emailID" + i} css={{ marginTop: "10px" }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        required
                        inputProps={{ maxLength: 50 }}
                        value={formik.values["emailID" + i]}
                        error={formik.touched["emailID" + i] && Boolean(formik.errors["emailID" + i])}
                        helperText={formik.touched["emailID" + i] && formik.errors["emailID" + i]} fullWidth
                        label={localeText?.nomineeDetailsEmailID} variant="outlined"
                        onChange={formik.handleChange}
                    />
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                            <FormControl required fullWidth error={formik.touched["nomineeIdentificationType" + i] && Boolean(formik.errors["nomineeIdentificationType" + i])} css={{ marginTop: "10px" }}>
                                <InputLabel
                                    shrink
                                >
                                   {localeText?.nomineeDetailsNomineeIdentificationDetail}
                                </InputLabel>
                                <Select
                                    id={"nomineeIdentificationType" + i}
                                    name={"nomineeIdentificationType" + i}
                                    value={formik.values["nomineeIdentificationType" + i]}
                                    onChange={formik.handleChange}
                                    size="small"
                                    input={
                                        <OutlinedInput
                                            notched
                                            label={localeText?.nomineeDetailsNomineeIdentificationDetail}
                                        />
                                    }
                                >
                                    <MenuItem value="">{localeText?.nomineeDetailsSelectValue}</MenuItem>
                                    {identityDetails?.map(opt => <MenuItem value={opt.documentName}>{opt.documentName}</MenuItem>)}
                                </Select>
                                <FormHelperText>{formik.touched["nomineeIdentificationType" + i] && formik.errors["nomineeIdentificationType" + i]}</FormHelperText>
                            </FormControl>
                        </Grid>
                <Grid item xs={12} md={6} lg={3}>
                    <StyledTextField id={"nomineeIdentificationDetail" + i} name={"nomineeIdentificationDetail" + i} css={{ marginTop: "10px" }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        required
                        inputProps={{ maxLength: 50 }}
                        value={formik.values["nomineeIdentificationDetail" + i]}
                        error={formik.touched["nomineeIdentificationDetail" + i] && Boolean(formik.errors["nomineeIdentificationDetail" + i])}
                        helperText={formik.touched["nomineeIdentificationDetail" + i] && formik.errors["nomineeIdentificationDetail" + i]} fullWidth
                        label={localeText?.nomineeDetailsIdentificationNumber} variant="outlined"
                        onChange={formik.handleChange}
                    />
                </Grid>


                {isMinorNominee(formik.values["dateOfBirth" + i]) &&
                    <>
                        <Grid item xs={12}>
                            <Typography variant="body1" css={{ fontWeight: "bold" }}>
                                {localeText?.nomineeDetailsGuardianDetails}
                            </Typography>
                        </Grid>

                        {i <= 1 && <Grid item xs={12}>
                            <FormControl>
                                <FormControlLabel control={<Checkbox name={"guardAddressSameAs" + i} id={"guardAddressSameAs" + i} checked={formik.values["guardAddressSameAs" + i]} onChange={(e) => { handleAddressSame(e, i, true); formik.handleChange(e) }} />}
                                    label={<Typography variant='body2'>
                                        {localeText?.nomineeDetailsAddressNominee1}
                                    </Typography>}
                                />
                            </FormControl>
                        </Grid>}

                        <Grid item xs={12} md={6} lg={3}>
                            <FormControl required fullWidth error={formik.touched["guardPrefix" + i] && Boolean(formik.errors["guardPrefix" + i])} css={{ marginTop: "10px" }}>
                                <InputLabel
                                    shrink
                                >
                                   {localeText?.nomineeDetailsPrefix}
                                </InputLabel>
                                <Select
                                    id={"guardPrefix" + i}
                                    name={"guardPrefix" + i}
                                    value={formik.values["guardPrefix" + i]}
                                    onChange={formik.handleChange}
                                    size="small"
                                    input={
                                        <OutlinedInput
                                            notched
                                            label={localeText?.nomineeDetailsPrefix}
                                        />
                                    }
                                >
                                    <MenuItem value="">{localeText?.nomineeDetailsSelectValue}</MenuItem>
                                    {prefixOptions.map(opt => <MenuItem value={opt.value}>{opt.label}</MenuItem>)}
                                </Select>
                                <FormHelperText>{formik.touched["guardPrefix" + i] && formik.errors["guardPrefix" + i]}</FormHelperText>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6} lg={3}>
                            <StyledTextField id={"nameOfGuardian" + i} name={"nameOfGuardian" + i} css={{ marginTop: "10px" }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                required
                                inputProps={{ maxLength: 50 }}
                                value={formik.values["nameOfGuardian" + i]}
                                error={formik.touched["nameOfGuardian" + i] && Boolean(formik.errors["nameOfGuardian" + i])}
                                helperText={formik.touched["nameOfGuardian" + i] && formik.errors["nameOfGuardian" + i]} fullWidth
                                label={localeText?.nomineeDetailsNameofGuardian} variant="outlined"
                                onChange={formik.handleChange}
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={3}>
                            <FormControl required fullWidth error={formik.touched["guardRelationship" + i] && Boolean(formik.errors["guardRelationship" + i])} css={{ marginTop: "10px" }}>
                                <InputLabel
                                    shrink
                                >
                                   {localeText?.nomineeDetailsGuardianRelationshipwithNominee}
                                </InputLabel>
                                <Select
                                    id={"guardRelationship" + i}
                                    name={"guardRelationship" + i}
                                    value={formik.values["guardRelationship" + i]}
                                    onChange={formik.handleChange}
                                    size="small"
                                    input={
                                        <OutlinedInput
                                            notched
                                            label={localeText?.nomineeDetailsGuardianRelationshipwithNominee}
                                        />
                                    }
                                >
                                    <MenuItem value="">{localeText?.nomineeDetailsSelectValue}</MenuItem>
                                    {relationOptions.filter(opt => opt.relationType == "Nominee").map(opt => <MenuItem value={opt.relationship}>{opt.relationship}</MenuItem>)}
                                </Select>
                                <FormHelperText>{formik.touched["guardRelationship" + i] && formik.errors["guardRelationship" + i]}</FormHelperText>
                            </FormControl>
                        </Grid>

                        {i > 1 && <Grid item xs={12}>
                            <FormControl>
                                <FormControlLabel control={<Checkbox name={"guardAddressSameAs" + i} id={"guardAddressSameAs" + i} checked={formik.values["guardAddressSameAs" + i]} onChange={(e) => { handleAddressSame(e, i, true); formik.handleChange(e) }} />}
                                    label={<Typography variant='body2'>
                                        {localeText?.nomineeDetailsAddressNominee1}
                                    </Typography>}
                                />
                            </FormControl>
                        </Grid>}
                        <Grid item xs={12} md={6} lg={3}>
                            <StyledTextField id={"guardAddress" + i} name={"guardAddress" + i} css={{ marginTop: "10px" }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                required
                                inputProps={{ maxLength: 200 }}
                                value={formik.values["guardAddress" + i]}
                                error={formik.touched["guardAddress" + i] && Boolean(formik.errors["guardAddress" + i])}
                                helperText={formik.touched["guardAddress" + i] && formik.errors["guardAddress" + i]} fullWidth
                                label={localeText?.nomineeDetailsAddress} variant="outlined"
                                onChange={formik.handleChange}
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={3}>
                            <Autocomplete
                                css={{ marginTop: "10px" }}
                                key={formik.values["guardPincode" + i]}
                                id={"guardPincode" + i} name={"guardPincode" + i}
                                value={formik.values["guardPincode" + i] || ""}
                                open={open?.["guard" + i]}
                                onOpen={() => {
                                    setOpen({ ...open, ["guard" + i]: true });
                                }}
                                onClose={() => {
                                    setOpen({ ...open, ["guard" + i]: false });
                                }}
                                options={pincodeOptions}
                                disablePortal
                                filterOptions={(x) => x}
                                loading={open?.["guard" + i] && pincodeOptions.length == 0}
                                renderOption={(props, searchedItem, state) => {
                                    return getOptionComponent(searchedItem, i, true)
                                }}
                                isOptionEqualToValue={(option, value) => { return option.pinCode === value }}
                                getOptionLabel={(option) => { return option }}
                                renderInput={(params) => <StyledTextField {...params} fullWidth variant="outlined" label={localeText?.nomineeDetailsPINcode}
                                    onChange={e => handlePincodeSearch(e)}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    size="small"
                                    required
                                    id={"guardPincode" + i} name={"guardPincode" + i}
                                    error={formik.touched["guardPincode" + i] && Boolean(formik.errors["guardPincode" + i])}
                                    helperText={formik.touched["guardPincode" + i] && formik.errors["guardPincode" + i]}
                                />}
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={3}>
                            <StyledTextField id={"guardCity" + i} name={"guardCity" + i} css={{ marginTop: "10px" }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                required
                                value={formik.values["guardCity" + i]}
                                error={formik.touched["guardCity" + i] && Boolean(formik.errors["guardCity" + i])}
                                helperText={formik.touched["guardCity" + i] && formik.errors["guardCity" + i]} fullWidth
                                label={localeText?.nomineeDetailsCity} variant="outlined" disabled
                                onChange={formik.handleChange}
                            />
                        </Grid>
                        <Grid item xs={12} md={3} lg={3}>
                            <StyledTextField id={"guardState" + i} name={"guardState" + i} css={{ marginTop: "10px" }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                required
                                value={formik.values["guardState" + i]}
                                error={formik.touched["guardState" + i] && Boolean(formik.errors["guardState" + i])}
                                helperText={formik.touched["guardState" + i] && formik.errors["guardState" + i]} fullWidth
                                label={localeText?.nomineeDetailsState} variant="outlined" disabled
                                onChange={formik.handleChange}
                            />
                        </Grid>
                        <Grid item xs={12} md={3} lg={3}>
                            <StyledTextField id={"guardCountry" + i} name={"guardCountry" + i} css={{ marginTop: "10px" }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                required
                                value={formik.values["guardCountry" + i]}
                                error={formik.touched["guardCountry" + i] && Boolean(formik.errors["guardCountry" + i])}
                                helperText={formik.touched["guardCountry" + i] && formik.errors["guardCountry" + i]} fullWidth
                                label={localeText?.nomineeDetailsCountry} variant="outlined" disabled
                                onChange={formik.handleChange}
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={3}>
                            <StyledTextField id={"guardMobile" + i} name={"guardMobile" + i} css={{ marginTop: "10px" }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                required
                                inputProps={{ maxLength: 10 }}
                                value={formik.values["guardMobile" + i]}
                                error={formik.touched["guardMobile" + i] && Boolean(formik.errors["guardMobile" + i])}
                                helperText={formik.touched["guardMobile" + i] && formik.errors["guardMobile" + i]} fullWidth
                                label={localeText?.nomineeDetailsMob} variant="outlined"
                                onChange={formik.handleChange}
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={3}>
                            <StyledTextField id={"guardEmailID" + i} name={"guardEmailID" + i} css={{ marginTop: "10px" }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                required
                                inputProps={{ maxLength: 50 }}
                                value={formik.values["guardEmailID" + i]}
                                error={formik.touched["guardEmailID" + i] && Boolean(formik.errors["guardEmailID" + i])}
                                helperText={formik.touched["guardEmailID" + i] && formik.errors["guardEmailID" + i]} fullWidth
                                label={localeText?.nomineeDetailsEmailID} variant="outlined"
                                onChange={formik.handleChange}
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={3}>
                            <FormControl required fullWidth error={formik.touched["guardIdentificationType" + i] && Boolean(formik.errors["guardIdentificationType" + i])} css={{ marginTop: "10px" }}>
                                <InputLabel
                                    shrink
                                >
                                   {localeText?.nomineeDetailsGuardianIdentificationDetail}
                                </InputLabel>
                                <Select
                                    id={"guardIdentificationType" + i}
                                    name={"guardIdentificationType" + i}
                                    value={formik.values["guardIdentificationType" + i]}
                                    onChange={formik.handleChange}
                                    size="small"
                                    input={
                                        <OutlinedInput
                                            notched
                                            label={localeText?.nomineeDetailsGuardianIdentificationDetail}
                                        />
                                    }
                                >
                                    <MenuItem value="">{localeText?.nomineeDetailsSelectValue}</MenuItem>
                                    {identityDetails?.map(opt => <MenuItem value={opt.documentName}>{opt.documentName}</MenuItem>)}
                                </Select>
                                <FormHelperText>{formik.touched["guardIdentificationType" + i] && formik.errors["guardIdentificationType" + i]}</FormHelperText>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6} lg={3}>
                            <StyledTextField id={"guardIdentificationDetail" + i} name={"guardIdentificationDetail" + i} css={{ marginTop: "10px" }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                required
                                inputProps={{ maxLength: 50 }}
                                value={formik.values["guardIdentificationDetail" + i]}
                                error={formik.touched["guardIdentificationDetail" + i] && Boolean(formik.errors["guardIdentificationDetail" + i])}
                                helperText={formik.touched["guardIdentificationDetail" + i] && formik.errors["guardIdentificationDetail" + i]} fullWidth
                                label={localeText?.nomineeDetailsGuardianIdentificationNumber} variant="outlined"
                                onChange={formik.handleChange}
                            />
                        </Grid>


                        <Grid item xs={12}>
                            <Divider />
                        </Grid>
                        {/* <Grid item xs={12}>
                <Typography variant='body1' css={{ fontWeight: "bold" }}>
                    Nominee Share Details
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <FormControl>
                    <FormControlLabel control={<Checkbox name={"nomineeShareEqual"} id={"nomineeShareEqual"} checked={formik.values["nomineeShareEqual"]}
                        onChange={e => {
                            formik.setFieldValue("nomineeShareEqual", e.currentTarget.checked)
                            if (e.currentTarget.checked) {
                                if (nomineeCount == 3) {
                                    formik.setFieldValue("sharePercentage1", 34)
                                    formik.setFieldValue("sharePercentage2", 33)
                                    formik.setFieldValue("sharePercentage3", 33)
                                }
                                else if (nomineeCount == 2) {
                                    formik.setFieldValue("sharePercentage1", 50)
                                    formik.setFieldValue("sharePercentage2", 50)
                                }
                                else {
                                    formik.setFieldValue("sharePercentage1", 100)
                                }
                            }
                        }}
                    />}
                        label={<Typography variant='body2'>
                            {"Equal Share of each Nominee"}
                        </Typography>}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={12}>
                <Typography variant='body1' css={{ color: "#0000003b" }}>
                    Any odd lot after division shall be transferred to the first nominee mentioned in the form.
                </Typography>
            </Grid> */}

                    </>
                }
            </>
        )
    }

    nomineeField.push(
        <>
            <Grid item xs={12}>
                <Typography variant='body1' css={{ fontWeight: "bold" }}>
                    {localeText?.nomineeDetailsNomineeShareDetails}
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <FormControl>
                    <FormControlLabel control={<Checkbox name={"nomineeShareEqual"} id={"nomineeShareEqual"} checked={formik.values["nomineeShareEqual"]}
                        onChange={e => {
                            formik.setFieldValue("nomineeShareEqual", e.currentTarget.checked)
                            if (e.currentTarget.checked) {
                                if (nomineeCount == 3) {
                                    formik.setFieldValue("sharePercentage1", 34)
                                    formik.setFieldValue("sharePercentage2", 33)
                                    formik.setFieldValue("sharePercentage3", 33)
                                }
                                else if (nomineeCount == 2) {
                                    formik.setFieldValue("sharePercentage1", 50)
                                    formik.setFieldValue("sharePercentage2", 50)
                                }
                                else {
                                    formik.setFieldValue("sharePercentage1", 100)
                                }
                            }
                        }}
                    />}
                        label={<Typography variant='body2'>
                            {localeText?.nomineeDetailsEqualShareofeachNominee}
                        </Typography>}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={12}>
                <Typography variant='body1' css={{ color: "#0000003b" }}>
                    {localeText?.nomineeDetailsNomineeMentiond}
                </Typography>
            </Grid>
        </>
    )


    for (let i = 1; i <= nomineeCount; i++) {
        nomineeField.push(
            <Grid container item xs={12} spacing={3}>
                <Grid item xs={12} md={4}>
                    <StyledTextField id={"nameOfNomineeShare" + i} name={"nameOfNominee" + i} css={{ marginTop: "10px" }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        key={formik.values["nameOfNominee" + i]}
                        required
                        value={formik.values["nameOfNominee" + i]}
                        error={formik.touched["nameOfNominee" + i] && Boolean(formik.errors["nameOfNominee" + i])}
                        helperText={formik.touched["nameOfNominee" + i] && formik.errors["nameOfNominee" + i]} fullWidth
                        label={localeText?.nomineeDetailsNameofNominee} variant="outlined"
                        disabled
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <FormControl key={formik.values["relationship" + i]} required fullWidth error={formik.touched["relationship" + i] && Boolean(formik.errors["relationship" + i])} css={{ marginTop: "10px" }}>
                        <InputLabel
                            shrink
                        >
                            {localeText?.nomineeDetailsRelationshipwithNominee}
                        </InputLabel>
                        <Select
                            id={"relationshipShare" + i}
                            name={"relationship" + i}
                            value={formik.values["relationship" + i]}
                            size="small"
                            disabled
                            input={
                                <OutlinedInput
                                    notched
                                    label={localeText?.nomineeDetailsRelationshipwithNominee}
                                />
                            }
                        >
                            <MenuItem value="">{localeText?.nomineeDetailsSelectValue}</MenuItem>
                            {relationOptions.filter(opt => opt.relationType == "Nominee").map(opt => <MenuItem value={opt.relationship}>{opt.relationship}</MenuItem>)}
                        </Select>
                        <FormHelperText>{formik.touched["relationship" + i] && formik.errors["relationship" + i]}</FormHelperText>
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={4}>
                    <StyledTextField required id={"sharePercentage" + i} name={"sharePercentage" + i} css={{ marginTop: "10px" }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        value={formik.values["sharePercentage" + i]}
                        error={formik.touched["sharePercentage" + i] && Boolean(formik.errors["sharePercentage" + i])}
                        helperText={formik.touched["sharePercentage" + i] && formik.errors["sharePercentage" + i]} fullWidth
                        label={localeText?.nomineeDetailsSharePercentage} variant="outlined"
                        onChange={formik.handleChange}
                        // disabled={formik.values["nomineeShareEqual"]}
                        inputProps={{
                            maxlength: 3
                        }}
                    />
                </Grid>
            </Grid>
        )
    }
    return nomineeField
}

export default NomineeFields;
